import React from 'react'
import * as CONSTANTS from "../../CONSTANTS";
import { useEffect } from 'react';
import axios from 'axios';
import { useState } from 'react';
import { Link } from 'react-router-dom';

function ToursShortList() {

  const [listRandom, setListRandom]                           = useState([]);
  useEffect(() => {
    collectTourShortList();
  },[])

  const collectTourShortList = async () => {
    try{

      const getShort = await axios.get(CONSTANTS.API_URL + "tours/list/random" );
      //console.log(getShort.data);
      setListRandom(getShort.data);
    }catch(err){  
      console.log(err);
    }
  }
  
  return (
    <div className="content-section tour-list">
        <div className="container standard-tour-list">
            <h2 className="sub-title">Tour List</h2>
            {
              listRandom.length > 0 && (
                <div className="row rw">
                  {
                    listRandom.map((tour, index) => {
                      return <div className="col-md-3" key={index}>
                               <div className="tab-image-display"
                                  style={{ backgroundImage: `url(${tour.img_url})` }}>
                                </div>
                                <div className="title-box">
                                  <Link
                                    to={"/tour/" + tour._id}
                                    className="no-linking">
                                    {tour.name}
                                  </Link>
                                </div>
                                <div className="sub-line">
                                  {tour.provinces.map((province, index) => {
                                    return <span key={index}>{province}</span>
                                  })}
                                </div>
                                <div className="price-line">
                                  From <strong>{tour.price - tour.discount_number}</strong>
                                </div>
                            </div>
                    })
                  }
                </div>
              )
            }
            
        </div>
    </div>
  )
}

export default ToursShortList